export default __webpack_public_path__ + "static/media/grunge_footer_top.9d699b55.png";